import React, { forwardRef } from "react";

import { Flex, FlexProps } from "@magnetic/flex";

const HFlex = forwardRef<HTMLDivElement, FlexProps>((props: FlexProps, ref) => {
  return (
    <Flex gap={props.gap || "md"} ref={ref} direction="horizontal" {...props}>
      {props.children}
    </Flex>
  );
});
export { HFlex };
